<div class="optins">
  <label>
    <input type="checkbox" name="newsletter" [(ngModel)]="optins.news_and_alerts" (change)="checkOthers?.()">Keep me updated by email
  </label>
  <p>
    We'll send you occasional alerts<ng-container *ngIf="checkOthers">, plus <a href="#" (click)="expand($event)">our newsletters (click to expand)</a></ng-container>.
  </p>

  <div *ngIf="!checkOthers" class="granular">
    <h3>TYT Newsletters</h3>

    <ng-container *ngFor="let prefs of this.availablePrefs">
      <label>
        <input type="checkbox" name="newsletter" [(ngModel)]="optins[prefs.provider_id]">{{ prefs.label }}
      </label>
      <p>
        {{ prefs.summary }}
      </p>
    </ng-container>
  </div>
</div>
